// extracted by mini-css-extract-plugin
module.exports = {"prefix":"style_prefix__jZtwk"};